"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.UserLinksWrapper = exports.UserButton = exports.SVGWrapper = exports.SignInLink = exports.NavLink = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typography = require("../../typography");

var _link = _interopRequireDefault(require("../../link"));

var _topNav = require("../shared/top-nav.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavLink = (0, _styledComponents["default"])(_topNav.NavLink).withConfig({
  displayName: "desktop-user-navstyles__NavLink",
  componentId: "sc-1by17q2-0"
})(["display:flex;align-items:center;padding-bottom:12px;"]);
exports.NavLink = NavLink;
var SVGWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "desktop-user-navstyles__SVGWrapper",
  componentId: "sc-1by17q2-1"
})(["display:inline-flex;margin-right:8px;"]);
exports.SVGWrapper = SVGWrapper;
var SignInLink = (0, _styledComponents["default"])(_link["default"]).withConfig({
  displayName: "desktop-user-navstyles__SignInLink",
  componentId: "sc-1by17q2-2"
})(["display:'block';transition:opacity 0.25s ease-in-out;opacity:", ";"], function (props) {
  return props.isPending ? 0 : 1;
});
exports.SignInLink = SignInLink;
var Wrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "desktop-user-navstyles__Wrapper",
  componentId: "sc-1by17q2-3"
})(["display:none;@media ", "{padding-left:24px;min-width:fit-content;height:100%;display:flex;justify-content:center;align-items:center;}"], function (props) {
  return props.theme.queries.navbarBreakpoint;
});
exports.Wrapper = Wrapper;
var UserLinksWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "desktop-user-navstyles__UserLinksWrapper",
  componentId: "sc-1by17q2-4"
})(["display:flex;flex-direction:column;padding:24px 21px 12px 12px;width:fit-content;min-width:250px;& >:not(:first-child){padding-top:18px;}"]);
exports.UserLinksWrapper = UserLinksWrapper;
var UserButton = (0, _styledComponents["default"])(_typography.BaseTypographyComponent).withConfig({
  displayName: "desktop-user-navstyles__UserButton",
  componentId: "sc-1by17q2-5"
})(["", " --font-size-mim:1rem;--font-size-max:1rem;--letter-spacing:-0.4px;--font-weight:500;white-space:pre;&:after{content:'';position:absolute;top:-12px;left:-12px;right:-12px;height:44px;}display:flex;align-items:center;svg{margin-left:8px;animation:", ";animation-fill-mode:forwards;@keyframes open{100%{transform:rotate(180deg);}}}"], (0, _typography.getTypographyVariant)('subheading'), function (props) {
  return props.popoverOpen ? "open 0.5s" : "none";
});
exports.UserButton = UserButton;